<template>
    <div class="result-modal" :class="{ open: isLoaded }">
        <div class="modal-content relative" v-on-clickaway="closeModal">
            <div class="modal-header absolute">
                <div class="text-right cursor-pointer">
                    <i @click="closeModal" class="fas fa-times text-xl shadow-text-none"></i>
                </div>
            </div>
            <div class="modal-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'

export default {
    directives: {
        onClickaway: onClickaway
    },

    data() {
        return {
            isLoaded: false
        }
    },

    mounted() {
        setTimeout(() => {
            this.isLoaded = true
        }, 50)
    },

    methods: {
        closeModal() {
            this.isLoaded = false
            this.$emit('close')
        },

        closeByBackdrop(e) {
            if (!e.target.classList.contains('modal-backdrop')) {
                return
            }
            this.closeModal()
        }
    }
}
</script>

<style lang="scss" scoped>
.result-modal {
    width: 100%;
    height: 100%;
    position: fixed;
    // top: calc(var(--header-height));
    top: 0;
    left: 0;
    height: 100%;
    // max-height: calc(100% - ((var(--header-height) + var(--footer-height)) + 2rem));
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 90;
    overflow: auto;
    padding-top: 1rem;
    background-color: rgba(0, 0, 0, 0.5);

    .modal-content {
        background-color: #fff;
        padding: 1rem;
        width: 100%;
        max-width: 720px;
        overflow: hidden;
        border-radius: 0.75rem;
        height: 90%;
        opacity: 0;
        transition: 0.3s;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);

        @media screen and (max-width: 719px) {
            width: 95%;
            box-shadow: none;
        }

        @media (max-height: 735px) {
            zoom: 85%;
        }
        @media (max-height: 667px) {
            zoom: 83%;
        }
        @media (max-height: 620px) {
            zoom: 75%;
        }
        @media (max-height: 590px) {
            zoom: 70%;
        }

        .modal-header {
            top: 1rem;
            right: 1rem;
        }

        .modal-body {
            height: 100%;
        }
    }

    &.open {
        .modal-content {
            opacity: 1;
        }
    }
}
</style>